<template>
    <div class="pp-block-wrapper">
        <div class="pp-nav pp-nav-left" @click="goPrev" v-show="items_chunks.length > 1">
            <div></div>
        </div>
        <div class="pp-main-block" v-bind:class="{ 'no-chunks': hasNoChunks}">
            <div class="pp-logo-wrapper">
                <div class="pp-logo">
                    <img src="/img/pp_banner_logo.png" alt="Pearson+ logo">
                </div>
                <div class="pp-promo-text">
                    <div>
                      Included with your Pearson+ Subscription
                    </div>
                </div>
            </div>
            <div class="pp-products-block">
                <div class="pp-product-block" v-for="item in items_to_display">
                    <div class="pp-product-cover">
                        <img :src="item.image_medium || '/img/no_image_medium.gif'" v-bind="ADAattr('hidden')" alt="product cover">
                    </div>
                    <div class="pp-product-bookinfo">
                        <p class="pp-product-title">{{item.title|truncate(60)}}</p>
                        <p class="pp-product-author">{{item.author}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="pp-nav pp-nav-right" @click="goNext" v-show="items_chunks.length > 1">
            <div></div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            bundled_products: {
                type: Array
            }
        },
        data() {
            return {
                items_per_chunk: 3,
                current_chunk: 0,
                hasNoChunks: false
            }
        },
        mounted() {
            this.calc_items_per_chunk();
            window.addEventListener('resize', this.calc_items_per_chunk);
        },
        computed: {
            items_chunks() {
                return _.chunk(this.bundled_products, this.items_per_chunk);
            },
            items_to_display() {
                if (!this.items_chunks.length) return [];
                this.hasNoChunks = this.items_chunks.length == 1;
                return this.items_chunks[this.current_chunk];
            }
        },
        methods: {
            calc_items_per_chunk() {
                if (window.outerWidth < 550) {
                    this.items_per_chunk = 1;
                } else if (window.outerWidth < 700) {
                    this.items_per_chunk = 2
                } else {
                    this.items_per_chunk = 3;
                }
            },
            goPrev() {
                if (this.current_chunk <= 0) {
                    this.current_chunk = this.items_chunks.length - 1;
                } else {
                    this.current_chunk--
                }
            },
            goNext() {
                if (this.current_chunk >= this.items_chunks.length - 1) {
                    this.current_chunk = 0
                } else {
                    this.current_chunk++
                }
            }
        },
        filters: {
            truncate: function(value, limit) {
                if (value.length > limit) {
                    value = value.substring(0, (limit - 3)) + '...';
                }
                return value
            }
        }
    }
</script>

<style scoped lang="less">
    .pp-block-wrapper {
        @media screen and (min-width: 500px) {
            border: 1px solid #ccc;
        }
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 25px;

        .no-chunks {
            padding: 0 40px;
        }
    }

    .pp-products-block {
        display: flex;
    }

    .pp-logo-wrapper {
        @media screen and (min-width: 700px) {
            display: flex;
        }
    }

    .pp-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 24px;

        @media screen and (min-width: 500px) {
            height: 80px;
        }
    }

    .pp-logo img {
        width: 200px;
    }

    .pp-promo-text {
        font-size: 1.3em;
        text-align: center;
        display: flex;
        align-items: center;

        .pp-accent-color {
            color: rgb(244, 64, 4);
        }
    }

    .pp-product-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        padding: 5px 16px 0px;
    }

    .pp-nav {
        display: flex;
        align-items: center;
        padding: 0 5px;

        @media screen and (min-width: 500px) {
            padding: 0 5px;
        }

        &:hover {
            cursor: pointer;
            & > div {
                background-color: #f2f2f2;
            }
        }

        & > div {
            @diam: 32px;
            @diam-mobile: 24px;
            font-size: 1.5em;
            border: 1px solid #ccc;
            border-radius: 999px;
            width: @diam-mobile;
            height: @diam-mobile;
            @media screen and (min-width: 500px) {
                width: @diam;
                height: @diam;
            }
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .pp-product-bookinfo {
        width: 100%;
        max-width: 200px;
        min-height: 80px;
        & > p {
            padding: 0;
            margin: 0;
        }

        .pp-product-title {
            font-weight: 600;
        }
    }


    .pp-product-cover {
        img {
            height: 80px;
        }
    }

    .pp-main-block {
        flex: 1;
    }

    .pp-nav-right > div {
        &:after {
            font-family: 'SSAir', 'sans-serif';
            font-size: 14px;
            content: "\F501";
            transform: rotate(270deg);
            padding-top: 5px;
        }
    }
    .pp-nav-left > div {
        &:after {
            font-family: 'SSAir', 'sans-serif';
            font-size: 14px;
            content: "\F501";
            transform: rotate(90deg);
            padding-top: 5px;
        }
    }
</style>
